module.exports = __webpack_public_path__ + "img/b2798f8.jpg";